@if (!isAuthenticated) {
  <app-portal-navbar></app-portal-navbar>
}

<ion-content [fullscreen]="!isAuthenticated" [scrollEvents]="true">
  <div class="card-bg" [class.card-bg--public]="!isAuthenticated" [class.card-bg--shell]="isAuthenticated">
    <div class="card-container">

      <!-- ═══ HERO ═══ -->
      <div class="card-hero">
        <img src="assets/icon/favicon-9.png" alt="Gastro Management" class="card-mark" />
        <h1>Erik Oberbillig</h1>
        <p class="card-role">Inhaber &middot; Gastro Management Oberbillig</p>
        <p class="card-tagline">{{ 'card.tagline' | translate }}</p>
      </div>

      <!-- ═══ PRIMARY ACTIONS ═══ -->
      <div class="card-actions">
        <button class="card-btn card-btn--primary" type="button" (click)="downloadVCard()">
          <ion-icon name="person-add-outline"></ion-icon>
          {{ 'card.saveContact' | translate }}
        </button>
        <a class="card-btn" href="mailto:management@gastro-management.ch">
          <ion-icon name="mail-outline"></ion-icon>
          {{ 'card.sendEmail' | translate }}
        </a>
        <a class="card-btn" routerLink="/contact">
          <ion-icon name="calendar-outline"></ion-icon>
          {{ 'card.scheduleMeeting' | translate }}
        </a>
      </div>

      <a class="card-linkedin" href="https://www.linkedin.com/in/erik-oberbillig-14081a420/" target="_blank" rel="noopener noreferrer">
        <ion-icon name="logo-linkedin"></ion-icon>
        LinkedIn
      </a>

      <!-- ═══ PRODUCTS ═══ -->
      <div class="card-products">
        <p class="card-products-label">{{ 'card.productsLabel' | translate }}</p>
        <div class="card-products-grid">
          @for (p of products; track p) {
            @if (!p.external) {
              <a class="product-tile" [routerLink]="p.url">
                <img [src]="p.logoSrc" [alt]="p.name" />
              </a>
            }
            @if (p.external) {
              <a class="product-tile" [href]="p.url" target="_blank" rel="noopener noreferrer">
                <img [src]="p.logoSrc" [alt]="p.name" />
              </a>
            }
          }
        </div>
      </div>

    </div>
  </div>

  <app-portal-footer></app-portal-footer>
</ion-content>
